<template>
  <div class="input-card">
    <!-- 输入框区域 弹性占高 -->
    <div class="input-wrap">
      <a-textarea
        v-model:value="form.keyword"
        :rows="6"
        :maxlength="800"
        show-count
        placeholder="请输入案情、诉讼请求、答辩思路或需要生成的文书需求，例如：我是原告代理律师，现起诉被告归还借款本金20万元及利息……"
        :bordered="false"
        class="doc-textarea"
      />
      <!-- AI优化弹窗组件 -->
      <OptimizePanel
        :visible="optimizeVisible"
        :loading="optimizeLoading"
        :original-question="originalQuestion"
        :optimized-question="optimizedQuestion"
        @keep="keepQuestion"
        @close="keepQuestion"
        @replace="replaceQuestion"
        @retry="retryOptimize"
      />
    </div>

    <!-- 底部工具栏 固定贴底 -->
    <div class="toolbar">
      <div class="toolbar-left">
        <!-- <a-button type="text" @click="uploadFile" class="btn-upload">
          <img src="@/assets/casesearchImg/icon-up.png" class="icons">
          加密上传文件
        </a-button> -->
        <a-button type="text" @click="optimize" class="btn-ai">
          <img
            src="@/assets/casesearchImg/icon-recognition.png"
            class="icons"
          />
          智能优化问题
        </a-button>
      </div>
      <div class="toolbar-right">
        <a-button class="btn-search" size="large" @click="search">
          <img src="@/assets/casesearchImg/i-search.png" class="search-icon" />
          开始生成
        </a-button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({ name: "DocumentInput" });
import { reactive, ref, watch } from "vue";
import OptimizePanel from "@/components/casesearch/OptimizePanel.vue";
import { PolishQuestion } from "../../api/case/case";

// 双向绑定父组件 keyword
const props = defineProps({
  modelValue: {
    type: String,
    default: "",
  },
});
const emit = defineEmits(["update:modelValue", "search", "upload", "optimize"]);

// 表单数据
const form = reactive({
  keyword: props.modelValue,
});

// 同步父组件v-model
watch(
  () => form.keyword,
  (val) => emit("update:modelValue", val),
);

// 上传文件
// const uploadFile = () => {
//   emit("upload")
// }

// AI优化逻辑
const optimize = async () => {
  if (!form.keyword.trim()) return;
  emit("optimize");
  optimizeVisible.value = true;
  optimizeLoading.value = true;
  originalQuestion.value = form.keyword;

  try {
    const res = await PolishQuestion({ question: form.keyword });
    if (res.isSuccess && res.data) {
      originalQuestion.value = res.data.originalQuestion;
      optimizedQuestion.value = res.data.polishedQuestion;
    }
  } catch (err) {
    console.error("智能优化失败", err);
  } finally {
    optimizeLoading.value = false;
  }
};

// 点击检索
const search = () => {
  emit("search", { keyword: form.keyword });
};

// AI优化面板回调
const keepQuestion = () => {
  optimizeVisible.value = false;
};
const replaceQuestion = (question) => {
  form.keyword = question;
  optimizeVisible.value = false;
};
const retryOptimize = () => {
  optimize();
};

// AI优化状态变量
const optimizeVisible = ref(false);
const optimizeLoading = ref(false);
const originalQuestion = ref("");
const optimizedQuestion = ref("");
</script>

<style scoped lang="less">
.input-card {
  width: 100%;
  margin-top: 24px;
  padding: 24px 24px 0;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #dfe6f2;
  box-shadow: 0 5px 18px rgba(35, 68, 120, 0.05);
  /* 垂直弹性，让工具栏贴底部 */
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}

/* 输入区域自动占剩余高度，把工具栏压到底 */
.input-wrap {
  flex: 1;
}

.doc-textarea {
  font-size: 15px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end; /* 按钮与textarea底部字数统计对齐 */
  margin-top: 16px;
  border: none;
}
.toolbar-left {
  display: flex;
  gap: 12px;
}
.toolbar-right {
  flex-shrink: 0;
}
:where(.css-dev-only-do-not-override-z4nrqd).ant-btn-default:not(
    :disabled
  ):hover {
  color: #ffffff !important;
}
// 按钮通用图标
.icons {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

// 上传按钮
.btn-upload {
  background: #ffffff;
  box-shadow: 0px 8px 24px 0px rgba(36, 70, 130, 0.08);
  border-radius: 10px;
  border: 1px solid #d8e0ed;
  font-weight: 600;
  font-size: 14px;
  color: #31425e;
}

// AI优化按钮
.btn-ai {
  background: #f2f7ff;
  box-shadow: 0px 8px 24px 0px rgba(36, 70, 130, 0.08);
  border-radius: 10px;
  border: 1px solid #d9e7ff;
  font-weight: 600;
  font-size: 14px;
  height: 36px;
  color: #1768ff;
  &:hover {
    background: #f2f7ff;
    color: #1768ff;
  }
}

// 检索按钮
.btn-search {
  background: linear-gradient(162deg, #1568ff 0%, #0f5ce6 100%);
  box-shadow: 0px 8px 24px rgba(36, 70, 130, 0.08),
    0px 8px 18px rgba(23, 104, 255, 0.2);
  border-radius: 10px;
  border: 1px solid #1768ff;
  font-size: 15px;
  padding: 0 24px;
  height: 36px;
  color: #fff;
}
.search-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  margin-bottom: 4px;
}

// 深度修改textarea样式
:deep(.ant-input) {
  resize: none;
  font-size: 15px;
}

// AI优化面板间距
:deep(.optimize-panel) {
  margin: 18px 0;
}
</style>
